<template>
    <!-- 后台首页 -->
    <div  class="hp">
        <el-container>
            <el-header height="100px">
                <Navigation />
            </el-header>
            <el-container>
                <el-aside style="background-color: #fff"  class="menu" @scroll="syncMenuScroll">
                    <el-menu :default-active="activeIndex" :unique-opened="true" text-color="#666"  @select="handleSelect">
                        <!-- 工作台 -->
                         <el-menu-item index="1">
                            <img v-if="activeIndex==1" class="logo-img" src="../../../assets/images/hp/gongzuotai-bai.png" alt="">
                            <img v-else class="logo-img" src="../../../assets/images/hp/gongzuotai-hei.png" alt="">
                            <span slot="title" class="ziti">工作台</span>
                        </el-menu-item>
                        <!--  舱位管理  -->
                        <el-submenu index="2">
                            <template slot="title">
                                <img class="logo-img" src="../../../assets/images/hp/cangwei.png" alt="">
                                <span  class="ziti">舱位管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item  class="ziti" index="2-1">精选运价</el-menu-item>
                                <el-menu-item  class="ziti" index="2-2">现舱市场</el-menu-item>
                                <el-menu-item  class="ziti" index="2-3">代理商运费模版</el-menu-item>
                                <el-menu-item  class="ziti" index="2-4">代理商运价统计</el-menu-item>
                                <!-- <el-menu-item  class="ziti" index="2-5">快速发布</el-menu-item> -->
                            </el-menu-item-group>
                        </el-submenu>
                        <!-- <el-submenu index="8">
                            <template slot="title">
                                <img class="logo-img" src="../../../assets/images/hp/cangwei.png" alt="">
                                <span  class="ziti">快速发布</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item  class="ziti" index="8-1">运价列表</el-menu-item>
                                <el-menu-item  class="ziti" index="8-2">运价模板</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu> -->
                        <!--  订单管理  -->
                        <el-submenu index="3">
                            <template slot="title">
                                <img class="logo-img" src="../../../assets/images/hp/dingdan.png" alt="">
                                <span  class="ziti">订单管理</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item  class="ziti" index="3-1">精选运价</el-menu-item>
                                <el-menu-item  class="ziti" index="3-2">现舱市场</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <!-- 账单管理 -->
                        <el-menu-item index="4">
                            <img v-if="activeIndex==4" class="logo-img" src="../../../assets/images/hp/zhangdan-bai.png" alt="">
                            <img v-else class="logo-img" src="../../../assets/images/hp/zhangdan-hei.png" alt="">
                            <span  class="ziti" slot="title">账单管理</span>
                        </el-menu-item>
                        <!--  运费模版  -->
                        <el-submenu index="5">
                            <template slot="title">
                                <img class="logo-img" src="../../../assets/images/hp/moban-hei.png" alt="">
                                <span  class="ziti">运费模版</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item  class="ziti" index="5-1">舱位发布</el-menu-item>
                                <el-menu-item  class="ziti" index="5-2">批量发布</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <!--  消息通知  -->
                        <el-menu-item index="6">
                            <img v-if="activeIndex==6" class="logo-img" src="../../../assets/images/hp/xiaoxi-bai.png" alt="">
                            <img v-else class="logo-img" src="../../../assets/images/hp/xiaoxi-hei.png" alt="">
                            <!-- <span slot="title" class="ziti">消息通知{{unread_num}}<span class="dian"></span></span> -->
                            <span slot="title" class="ziti" v-if="unread_num==0">
                                消息通知
                            </span>
                            <el-badge v-else slot="title" :value="unread_num" :max="99" class="item">
                                <span class="ziti">消息通知</span>
                            </el-badge>
                        </el-menu-item>
                        <!--  账号管理  -->
                        <el-submenu index="7">
                            <template slot="title">
                                <img class="logo-img" src="../../../assets/images/hp/shezhi.png" alt="">
                                <span class="ziti">账号设置</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item  class="ziti" index="7-1">个人资料</el-menu-item>
                                <el-menu-item  class="ziti" index="7-2">我的钱包</el-menu-item>
                                <el-menu-item  class="ziti" index="7-3">会员权益</el-menu-item>
                                <el-menu-item  class="ziti" index="7-4">操作日志</el-menu-item>
                                <!-- <el-menu-item  class="ziti" index="7-5">子账号</el-menu-item> -->
                                <el-menu-item  class="ziti" index="7-6">平台协议</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>
                    <div class="back">
                        <div @click="fanhui"  class="fanhuiDiv">
                            <img class="fanhui-img" src="../../../assets/images/fanhuidhc.png" alt="">
                            <span>返回首页</span>
                        </div>
                    </div>
                </el-aside>
                <el-main  class="content" @scroll="syncContentScroll">
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
    
<script>
import Navigation from "./NavigationPage.vue";
import {supplierunReadNum,supplierInfo} from '@/api/api'
export default {
    components:{
        Navigation
    },
    data() {
        return {
            activeIndex: sessionStorage.getItem('menu') || '1',
            unread_num:JSON.parse(localStorage.getItem('userInfo')).supplierunread_num,
        }
    },
    methods: {
        handleSelect(key) {
            // console.log(key, keyPath);
            if(key=='1'){
                if( this.$route.path != "/ht/index-main" ){
                    this.$router.push('/ht/index-main')
                }
            }else if(key=='2-1'){
                if( this.$route.path != "/ht/freight" ){
                    this.$router.push('freight')
                }
            }else if(key=='2-2'){
                if( this.$route.path != "/ht/market" ){
                    this.$router.push('market')
                }
            }else if(key=='2-3'){
                if( this.$route.path != "/ht/agentTemplate" ){
                    this.$router.push('agentTemplate')
                }
            }else if(key=='2-4'){
                if( this.$route.path != "/ht/today" ){
                    this.$router.push('today')
                }
            }else if(key=='3-1'){
                if( this.$route.path != "/ht/freightOrder" ){
                    this.$router.push('freightOrder')
                }
            }else if(key=='3-2'){
                if( this.$route.path != "/ht/marketOrder" ){
                    this.$router.push('marketOrder')
                }
            }else if(key=='4'){
                if( this.$route.path != "/ht/billManagement" ){
                    this.$router.push('billManagement')
                }
            }else if(key=='5-1'){
                if( this.$route.path != "/ht/template" ){
                    this.$router.push('template')
                }
            }else if(key=='5-2'){
                if( this.$route.path != "/ht/batchtemplate" ){
                    this.$router.push('batchtemplate')
                }
            }else if(key=='6'){
                if( this.$route.path != "/ht/message" ){
                    this.$router.push('message')
                }
            }
            else if(key=='7-1'){
                if( this.$route.path != "/ht/personal" ){
                    this.$router.push('personal')
                }
            }
            else if(key=='7-2'){
                if( this.$route.path != "/ht/wallet" ){
                    this.$router.push('wallet')
                }
            }
            else if(key=='7-3'){
                if( this.$route.path != "/ht/member" ){
                    this.$router.push('member')
                }
            }
            else if(key=='7-4'){
                if( this.$route.path != "/ht/operationLog" ){
                    this.$router.push('operationLog')
                }
            }else if(key=='7-5'){
                if( this.$route.path != "/ht/subAccount" ){
                    this.$router.push('subAccount')
                }
            }
            else if(key=='7-6'){
                if( this.$route.path != "/ht/agreement" ){
                    this.$router.push('agreement')
                }
            }else if(key=='8-1'){
                if( this.$route.path != "/ht/freightQuick" ){
                    this.$router.push('freightQuick')
                }
            }
            // else if(key=='8-2'){
            //     if( this.$route.path != "/ht/freightQuick" ){
            //         this.$router.push('freightQuick')
            //     }
            // }

            sessionStorage.setItem('menu',key)
            this.activeIndex = key
            this.getUnReadNum()
            this.getSupplierInfo()
        },
        syncMenuScroll(event) {
            const content = this.$el.querySelector('.content');
            content.scrollTop = event.target.scrollTop;
        },
        syncContentScroll(event) {
            const menu = this.$el.querySelector('.menu');
            menu.scrollTop = event.target.scrollTop;
        },
        fanhui(){
            this.$router.push('/');
            sessionStorage.removeItem("menu");
        },
        // 调用接口  获取未读数量
        async getUnReadNum(){
          try {
            const res = await supplierunReadNum({token:localStorage.getItem('token')})
            // this.unread_num = res.data.unread_num;
            let storedObject = localStorage.getItem('userInfo');
            if (storedObject) { 
              let obj = JSON.parse(storedObject);
              obj.supplierunread_num = res.data.unread_num;
            //   obj.supplierunread_num+=1;
              this.unread_num=obj.supplierunread_num
              localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
            }      

            console.log(111,this.unread_num);
          } catch (error) {
            console.log(error,'失败');
          }
        },
        // 调用接口获取供应商认证信息
        async getSupplierInfo() {
            let supplier_id = JSON.parse(localStorage.getItem('userInfo')).supplier_id
            try {
            if (supplier_id==0 || supplier_id==null || supplier_id==undefined) { 
                this.$router.push('/ht/authentication')
                return 
            }
            const res = await supplierInfo({
                supplier_id:supplier_id
            }, {
                token: localStorage.getItem("token")
            });
            if(res.code==1){
                this.form = res.data;

                this.supplier_is_authentication=res.data.is_check
                this.supplier_reject_reason=res.data.reject_reason
                

                let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                userInfo.supplier_is_authentication=res.data.is_check
                userInfo.supplier_reject_reason=res.data.reject_reason
                userInfo.supplier_enterprise_name=res.data.enterprise_name
                userInfo.supplier_email=res.data.email
                userInfo.supplier_is_vip=res.data.is_vip
                userInfo.supplier_expire_time=res.data.expire_time
                localStorage.setItem('userInfo',JSON.stringify(userInfo))

                if(res.data.is_check!=2){
                    this.$router.push('/ht/authentication')
                }
            }
            } catch (error) {
                console.log(error,"获取失败");
            }
        },
    },
    mounted() {
        this.getUnReadNum()
    },
    beforeDestroy() {

    },
}
</script>
    
<style style lang="scss" scoped>
.el-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0;
    z-index: 999;
}

.el-aside{
    height: 100%;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    font-size: 16px;
    color: #666666;
    margin-top: 100px;

    width: 208px !important;
    padding: 0 20px;
    box-sizing: content-box;
}

.el-main{
    // background: pink;
    height: 100%;

    margin-top: 100px;
    margin-left: 32px;
    padding: 0;
}

.logo-img{
    width: 20px;
    height: 20px;
    margin-right: 16px;
}

.back{
    text-align: center;
    .fanhuiDiv{
        width: 208px;
        height: 50px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        font-size: 16px;
        color: #0B213F;
        border: 0;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;
    }

    .fanhui-img{
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
}

.el-menu{
    border: 0;
    height: 700px;
}

.el-menu-item.is-active {
    width: 208px;
    // height: 50px;
    background: #0073F5;
    // background: #064FAF;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #FFFFFF;

    // margin-left: 20px;
}

.ziti{
    font-size: 16px !important;
    position: relative;
    .dian{
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 5px;
        background: #FE3300;
        // margin-left: 10px;
        position: absolute;
        top: -5px;
        right: -15px;
    }
}

.el-submenu__title{
    font-size: 16px !important;
    color: pink;
}

.menu, .content {
  overflow-y: auto;
  height: 800px; /* 根据需要调整高度 */
}

:deep(.el-badge){
    .el-badge__content.is-fixed{
        top: 14px;
        right: 0px
    }
}

</style>